import createMobxModel from './createMobxModel';

const UserRoles = createMobxModel({
  name: 'userRoles',

  fields: [
    'isAdmin',
    'isHelpDesk',
    'isPatientAdmin',
    'isProviderBroadcastListAdmin',
    'isRoleAdmin',
    'isTeamAdmin',
    'isVirtualWaitingRoomAdmin',
    'patientContextReporting',
    'patientDataAuditAdmin',
    'isScimAdmin',
    'patientDataReportAnalyticsEnabled',
    'reportingEnabled',
    'reportingEnabledOnAllOrgs',
    'tigerTouchPlusReportingEnabled',
    'isPersonaManagementAdmin',
    'isClinicalWorkflow',
    'isClinicalWorkflowInsights',
    'isArchivingViewer',
    'basicAdminPermissions',
  ],

  relations: {
    one: {
      organization: { type: 'organization' },
    },
  },
});

export default UserRoles;
